import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/403/Page";

export const PATH = "/vendors/403";

const error403: NextPage = () => (
	<>
		<NskHead title="権限エラー" />
		<Component />
	</>
);

export default error403;
